import { Component, Input } from '@angular/core';
import { muckpileQuery } from '@models';

@Component({
    selector: 'muckpile-statistics',
    templateUrl: './muckpile-statistics.component.html',
    styleUrls: ['./muckpile-statistics.component.scss']
})
export class MuckpileStatisticsComponent {
    @Input() details: muckpileQuery.details.MuckpileStats;
    @Input() areaUnit: string | null;
    @Input() particleSizeUnit: string | null;
}